// Firebase configuration for web
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, initializeAuth, browserLocalPersistence, indexedDBLocalPersistence } from 'firebase/auth';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Resolve `getReactNativePersistence` robustly — the `firebase/auth` wrapper
// package does NOT export it from its RN bundle; only the scoped
// `@firebase/auth` package does. Without this, RN auth falls back to
// in-memory persistence and the user is signed out on every app restart.
let getReactNativePersistence;
try {
  // eslint-disable-next-line global-require
  getReactNativePersistence = require('@firebase/auth').getReactNativePersistence;
} catch (_e) { /* ignore */ }
if (typeof getReactNativePersistence !== 'function') {
  try {
    // eslint-disable-next-line global-require
    getReactNativePersistence = require('@firebase/auth/dist/rn/index.js').getReactNativePersistence;
  } catch (_e) { /* ignore */ }
}
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { Platform } from 'react-native';

const firebaseConfig = Platform.OS === 'web'
  ? {
      apiKey: "AIzaSyB5xT3pwzhqPqs4ulx9rtgWne39Pxr2H3Q",
      authDomain: "nibjobs-dev.firebaseapp.com",
      projectId: "nibjobs-dev",
      storageBucket: "nibjobs-dev.firebasestorage.app",
      messagingSenderId: "921124469397",
      appId: "1:921124469397:web:fbfe41c7f0eff695a9f99c",
      measurementId: "G-427ZVFZS6G"
    }
  : {
      apiKey: "AIzaSyCYYavl-JsiPGcFhWSw7vGMPCbVhqt5pBQ",
      authDomain: "nibjobs-dev.firebaseapp.com",
      projectId: "nibjobs-dev",
      storageBucket: "nibjobs-dev.firebasestorage.app",
      messagingSenderId: "921124469397",
      appId: "1:921124469397:android:4dcb0020fee8cb5ca9f99c"
    };

// Initialize Firebase with proper persistence
let app;
let auth;
let appCheck;

if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
  
  // Initialize App Check for web only (provides protection against abuse)
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      // Check if running on localhost
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      
      if (isLocalhost) {
        // Skip App Check for local development
        console.log('App Check: Skipped for localhost (development mode)');
      } else {
        // Production: Use ReCaptcha v3 for App Check
        const reCaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
        
        appCheck = initializeAppCheck(app, {
          provider: new ReCaptchaV3Provider(reCaptchaSiteKey),
          isTokenAutoRefreshEnabled: true,
        });
        
        console.log('App Check initialized successfully');
      }
    } catch (error) {
      console.warn('App Check initialization failed:', error);
    }
  }
  
  // Use appropriate persistence based on platform
  if (Platform.OS === 'web') {
    auth = initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence]
    });
  } else {
    // React Native — use AsyncStorage persistence so sign-in state is
    // restored across app restarts. `getAuth(app)` alone gives in-memory
    // persistence only (user is signed out on every cold start).
    if (typeof getReactNativePersistence === 'function') {
      try {
        auth = initializeAuth(app, {
          persistence: getReactNativePersistence(AsyncStorage),
        });
      } catch (e) {
        // If auth was already initialized for this app (e.g. by App.tsx),
        // reuse that instance rather than creating a non-persistent one.
        console.warn('initializeAuth threw, reusing existing auth instance:', e?.message || e);
        auth = getAuth(app);
      }
    } else {
      console.error('❌ getReactNativePersistence unavailable — auth state WILL NOT persist.');
      auth = getAuth(app);
    }
  }
} else {
  app = getApp();
  // Get existing auth instance - don't reinitialize
  auth = getAuth(app);
}

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export { auth, appCheck };

// Initialize Functions with us-central1 region
export const functions = getFunctions(app, 'us-central1');

// Web push messaging — only initialize on web
let webMessaging = null;
if (Platform.OS === 'web' && typeof window !== 'undefined') {
  try {
    const { getMessaging } = require('firebase/messaging');
    webMessaging = getMessaging(app);
  } catch (e) {
    console.warn('Firebase Messaging not available:', e);
  }
}
export { webMessaging };

export default app;